module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "ui active centered inline large loader"
  })]) : _c('div', {
    staticClass: "ui grid",
    staticStyle: {
      "padding": "20px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "fourteen wide column"
  }, [_c('div', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alertOnCategoryTypeNameChange),
      expression: "alertOnCategoryTypeNameChange"
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "id": "checkbox312455"
    },
    domProps: {
      "checked": Array.isArray(_vm.alertOnCategoryTypeNameChange) ? _vm._i(_vm.alertOnCategoryTypeNameChange, null) > -1 : (_vm.alertOnCategoryTypeNameChange)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.alertOnCategoryTypeNameChange,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.alertOnCategoryTypeNameChange = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.alertOnCategoryTypeNameChange = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.alertOnCategoryTypeNameChange = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox312455"
    }
  }, [_vm._v("\n                Main Category: Alert if Product Type changes\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alertOnCategoryGroupChange),
      expression: "alertOnCategoryGroupChange"
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "id": "checkbox312456"
    },
    domProps: {
      "checked": Array.isArray(_vm.alertOnCategoryGroupChange) ? _vm._i(_vm.alertOnCategoryGroupChange, null) > -1 : (_vm.alertOnCategoryGroupChange)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.alertOnCategoryGroupChange,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.alertOnCategoryGroupChange = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.alertOnCategoryGroupChange = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.alertOnCategoryGroupChange = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox312456"
    }
  }, [_vm._v("\n                Main Category: Alert if Product Group changes\n              ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "six wide column"
  }, [_c('button', {
    class: _vm.dirty ? 'ui primary button' : 'ui disabled primary button',
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "ui basic button",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "six wide column"
  }, [_c('div', {
    staticClass: "ui header"
  }, [_vm._v("Configuration")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1963d8dd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/CategoryChangeConfig.vue
// module id = 731
// module chunks = 2